import { render, staticRenderFns } from "./MediaColumn.vue?vue&type=template&id=bbfe99c6"
import script from "./MediaColumn.vue?vue&type=script&lang=js"
export * from "./MediaColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports